import React from 'react';

const CheckboxWithLabel = ({
                               label,
                               checked,
                               onChange,
                               required = false,
                               className = '',
                           }) => {
    return (
        <div className={`d-flex align-items-center ${className}`}>
            <input
                type="checkbox"
                className="form-check-input me-2 mt-0"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                required={required}
            />
            <label className="mb-0 me-2">{label}</label>
        </div>
    );
};

export default CheckboxWithLabel;
